export default "__VITE_ASSET__uMohyTz___"